<template>
    <div>
        <div id="map" style="width:600px;height:400px;"></div>
    </div>
</template>

<script>
import L from "leaflet";

export default {
    name: "Navigation",
    components: {},

    props: ['zone'],

    data: () => ({
        map: null,
    }),

    computed: {
        image() {
            if (this.zone.map_link) {
                return this.zone.map_link;
            }

            return 'uqm_map_full.png';
        },
        desks() {
          return this.zone.desks.filter(desk => {
            return desk.position && desk.position.center && desk.position.center[0];
          });
        },
    },

    mounted() {
        this.load();
        this.paintDesks();
    },

    methods: {
        paintDesks() {
            this.desks.forEach(item => {
                if (!item.position) {
                    return;
                }
                if (item.position.type === 'circle') {
                    L.circle(item.position.center, {color: "red", radius: item.position.radius, weight: 1})
                        .addTo(this.map);

                    return;
                }

                L.rectangle([
                    [item.position.center[0] + item.position.height, item.position.center[1] - item.position.width],
                    [item.position.center[0] - item.position.height, item.position.center[1] + item.position.width],
                ], {color: "red", weight: 1})
                    .addTo(this.map);
            });
        },
        setZoom() {
            //determine desk most left, top, right and bottom value!
            if (this.desks.length === 0) {
                return; // TODO set ZOOM to all of the map!
            }

            let [l, t] = this.desks[0].position.center;
            let [r, b] = this.desks[0].position.center;

            this.desks.forEach(desk => {
                l = Math.min(l, desk.position.center[0]);
                b = Math.min(b, desk.position.center[1]);
                r = Math.max(r, desk.position.center[0]);
                t = Math.max(t, desk.position.center[1]);
            })

            this.map.fitBounds([
                [l, t],
                [r, b]
            ]);
        },
        load() {
            const img = new Image();

            img.onload = () => {
                let minZoom = - Math.ceil( Math.max(img.width + img.height) / 1000 );
                this.map = L.map('map', {
                    crs: L.CRS.Simple,
                    minZoom: minZoom,
                    maxZoom: 2,
                    zoomSnap: 0.1,
                });
                this.createMap(img.width, img.height)
                this.setZoom();
            }

            img.src = this.image;
        },
        createMap(width, height) {
            var bounds = [[0, 0], [height, width]];
            var image = L.imageOverlay(this.image, bounds).addTo(this.map);
            this.map.setMaxBounds(bounds);

            this.map.setView([height / 2, width / 2], 1);
        },
    }
}
</script>

<style scoped>

</style>